export default "__VITE_ASSET__XRok$vAs__"